import { render } from "./PendingOrderDetails.vue?vue&type=template&id=fbc872ac"
import script from "./PendingOrderDetails.vue?vue&type=script&lang=js"
export * from "./PendingOrderDetails.vue?vue&type=script&lang=js"

import "./PendingOrderDetails.vue?vue&type=style&index=0&id=fbc872ac&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__